import { SuSyApi } from './susyApi';

export const completeRegistration = async (code: string, password: string) => {
    await SuSyApi.post('/user/completeRegistration', {
        code,
        password,
    });
};

export const registrationCompletionCheck = async (
    email: string
): Promise<boolean> => {
    const { data } = await SuSyApi.post(`/user/isRegistrationCompleted`, {
        email,
    });

    return data;
};
